<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageShell from '@/Components/UI/PageShell.vue'
import UiCard from '@/Components/UI/UiCard.vue'
import PaymentBlock from '@/Components/Deliveries/PaymentBlock.vue'
import { useI18n } from 'vue-i18n'
import { useCurrency } from '@/composables/useCurrency.js'

defineOptions({ layout: AppLayout })
const { t } = useI18n()
const { formatDateTime } = useCurrency()

defineProps({
  delivery: { type: Object, required: true },
})
</script>

<template>
  <PageShell
    :title="t('deliveries.show.title')"
    :back-href="`/rentals/${delivery.rental_id}`"
  >
    <UiCard :title="t('deliveries.show.details')">
      <dl class="grid grid-cols-2 gap-3 text-sm">
        <div>
          <dt class="text-[color:var(--muted)]">{{ t('deliveries.columns.kind') }}</dt>
          <dd class="fw-value mt-0.5 text-[color:var(--ink)]">
            {{ delivery.kind === 'handover' ? t('deliveries.kind.handover') : t('deliveries.kind.pickup') }}
          </dd>
        </div>
        <div>
          <dt class="text-[color:var(--muted)]">{{ t('deliveries.columns.status') }}</dt>
          <dd class="mt-0.5">
            <span class="pill" :class="`pill--${delivery.status}`">{{ delivery.status }}</span>
          </dd>
        </div>
        <div v-if="delivery.address">
          <dt class="text-[color:var(--muted)]">{{ t('deliveries.columns.address') }}</dt>
          <dd class="fw-value mt-0.5 text-[color:var(--ink)]">{{ delivery.address }}</dd>
        </div>
        <div v-if="delivery.scheduled_for">
          <dt class="text-[color:var(--muted)]">{{ t('deliveries.columns.scheduled') }}</dt>
          <dd class="fw-value mt-0.5 text-[color:var(--ink)]">{{ formatDateTime(delivery.scheduled_for) }}</dd>
        </div>
        <div v-if="delivery.driver_name">
          <dt class="text-[color:var(--muted)]">{{ t('deliveries.columns.driver') }}</dt>
          <dd class="fw-value mt-0.5 text-[color:var(--ink)]">{{ delivery.driver_name }}</dd>
        </div>
      </dl>
    </UiCard>

    <PaymentBlock :delivery="delivery" />
  </PageShell>
</template>

<style scoped>
.pill { display: inline-block; padding: 0.15rem 0.5rem; border-radius: 999px; font-size: 0.75rem; }
.pill--pending     { background: color-mix(in oklch, var(--warn) 14%, var(--surface));    color: var(--warn); }
.pill--assigned    { background: color-mix(in oklch, var(--accent) 14%, var(--surface));  color: var(--accent); }
.pill--in_progress { background: color-mix(in oklch, var(--accent) 22%, var(--surface));  color: var(--accent); }
.pill--completed   { background: color-mix(in oklch, var(--ok) 14%, var(--surface));       color: var(--ok); }
.pill--cancelled   { background: color-mix(in oklch, var(--muted) 12%, var(--surface));    color: var(--muted); }
</style>
